/* Presentation only. Shopify's existing SearchForm/PredictiveSearch own queries,
   results, keyboard result selection and native form submission. */
if (!customElements.get('lyma-header-search')) {
  customElements.define('lyma-header-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.toggle = this.querySelector('.lyma-header-search__toggle');
      this.pill = this.querySelector('.lyma-header-search__pill');
      if (!this.input || !this.toggle || !this.pill) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.toggle.setAttribute('role', 'button');
      this.toggle.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.hasAttribute('data-mobile-open')) this.close(true);
        else {
          this.setAttribute('data-mobile-open', '');
          this.toggle.setAttribute('aria-expanded', 'true');
          this.input.focus();
        }
      }, options);
      this.toggle.addEventListener('keydown', (event) => {
        if (event.code === 'Space') { event.preventDefault(); this.toggle.click(); }
      }, options);
      this.pill.addEventListener('click', (event) => {
        if (!event.target.closest('button')) this.input.focus();
      }, options);
      // Close result selection before the existing native reset handler runs.
      this.addEventListener('reset', () => this.querySelector('predictive-search')?.close?.(), { ...options, capture: true });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.close(this.mobile.matches);
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.close(false);
      }, options);
      this.mobile.addEventListener('change', () => this.close(false), options);
    }

    close(focusToggle = false) {
      this.querySelector('predictive-search')?.close?.();
      this.removeAttribute('data-mobile-open');
      this.toggle?.setAttribute('aria-expanded', 'false');
      if (this.contains(document.activeElement)) document.activeElement.blur();
      if (focusToggle && this.mobile?.matches) this.toggle.focus();
    }

    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
    }
  });
}
